const configuredApiUrl = import.meta.env.VITE_API_URL;
const apiUrl = configuredApiUrl === 'https://api.usegately.com' ? 'https://api.planbase.app' : (configuredApiUrl || 'https://api.planbase.app');

export const PLANBASE_CONFIG = {
  apiUrl,
  // For OAuth redirects, we need the full URL, not the proxied path
  oauthApiUrl: apiUrl,
  apiKey: import.meta.env.VITE_API_KEY || 'gately_jh4WZNpnNyqf3zZ70bxIiSjgiEVmAqEs',
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || '587686981540-thrpvo4for3qlif8pkvni8781n91uv98.apps.googleusercontent.com',
  projectId: import.meta.env.VITE_PROJECT_ID || '701d9cad-514f-49b3-965c-165985a4eb09',
  stripe: {
    publishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || 'pk_live_51SpNqgDVjC9LdoOZQiLzmXnti6ihnOMrDuEQrfESvj41y7YrOgJwtZOujwwIQDRknWYb5Kl27eOlHbL6Iie4K58900bFtVFHJz',
    prices: {
      pro_month: 'price_1U7ilXDVjC9LdoOZ8Uq6t5uP',
      pro_year: 'price_1U7inyDVjC9LdoOZmL0EIM5J',
      enterprise_month: 'price_1U7itNDVjC9LdoOZiYRBI3A4',
      enterprise_year: 'price_1U7iyoDVjC9LdoOZWjILCwPn',
    },
  },
  
  project: {
    id: '701d9cad-514f-49b3-965c-165985a4eb09',
    name: 'Planbase',
    site_name: 'Planbase',
    tagline: 'Build your story',
    description: 'The all-in-one platform where architects and designers upload, discover, and share their work.',
    primary_color: '#F97316',
    secondary_color: '#ffffff',
    logo_url: 'https://funuyosmhysvgvcndrxh.supabase.co/storage/v1/object/public/project-assets/projects/701d9cad-514f-49b3-965c-165985a4eb09/logos/logo-1754692078820-91t6j7hgnqr.png'
  },
  
  categories: [
    { value: 'agriculture', label: 'Agriculture' },
    { value: 'recreational', label: 'Recreational' },
    { value: 'transportation', label: 'Transportation' },
    { value: 'institutional', label: 'Institutional' },
    { value: 'residential', label: 'Residential' },
    { value: 'commercial', label: 'Commercial' },
    { value: 'industrial', label: 'Industrial' }
  ],
  
  drawingTypes: [
    { value: 'floor-plan', label: 'Floor Plan' },
    { value: 'roof-plan', label: 'Roof Plan' },
    { value: 'site-plan', label: 'Site Plan' },
    { value: 'elevation', label: 'Elevation' },
    { value: 'section', label: 'Section' },
    { value: 'perspective', label: 'Perspective' },
    { value: 'mechanical-drawing', label: 'Mechanical Drawing' },
    { value: 'others', label: 'Others' }
  ],
  
  styles: [
    { value: 'modern', label: 'Modern' },
    { value: 'contemporary', label: 'Contemporary' },
    { value: 'minimalist', label: 'Minimalist' },
    { value: 'traditional', label: 'Traditional' },
    { value: 'industrial', label: 'Industrial' }
  ],

  // Plan limits
  planLimits: {
    free: {
      maxProjects: 1,
      maxImagesPerProject: 10,
      canViewDiscovery: 10, // Number of projects free users can view
    },
    pro: {
      maxProjects: 50,
      maxImagesPerProject: 20,
      canViewDiscovery: -1, // Unlimited
    },
    enterprise: {
      maxProjects: -1, // Unlimited
      maxImagesPerProject: 50,
      canViewDiscovery: -1, // Unlimited
    }
  }
};
